import { render, staticRenderFns } from "./GuidanceBadge.vue?vue&type=template&id=202313e2&"
import script from "./GuidanceBadge.vue?vue&type=script&setup=true&lang=ts&"
export * from "./GuidanceBadge.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports